import './WithdrawalRequestCompleteModalStyle.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { formatDateToSlashDateTime } from 'views/utils/format/FormatDate';
import { formatNumber } from 'views/utils/format/FormatNumber';

type WithdrawalRequestCompleteModalProps = {
  isOpen: boolean;
  requestedWithdrawalAmount: number | undefined;
  withdrawalDate: string | undefined;
  onClose: () => void;
};

const formatAssetAmount = (amount: number | undefined) => (amount === undefined ? '-' : formatNumber(amount));

export const WithdrawalRequestCompleteModal = (props: WithdrawalRequestCompleteModalProps) => {
  const { isOpen, requestedWithdrawalAmount, withdrawalDate, onClose } = props;

  return (
    <ModalBase
      isOpen={isOpen}
      modalStyle={ModalStyle.confirmModal}
      onRequestClose={onClose}
      children={
        <div className="withdrawalRequestComplete">
          <div className="withdrawalRequestComplete_header">出金予約受付金額</div>
          <div className="withdrawalRequestComplete_amount">
            <span>{formatAssetAmount(requestedWithdrawalAmount)}</span>
            <span className="withdrawalRequestComplete_amountUnit">
              円({formatDateToSlashDateTime(withdrawalDate, false)})
            </span>
          </div>
          <div className="withdrawalRequestComplete_message">
            <div>・出金予約を受付ました。</div>
            <div>・出金余力への反映は、時間がかかる場合があります。</div>
            <div>※出金余力の更新は「出金余力更新」ボタンを押下してください</div>
          </div>
          <Button label="閉じる" buttonSize={ButtonSize.sizeM} fillType={FillType.primaryFill} onClick={onClose} />
        </div>
      }
    />
  );
};
